import { useEffect } from 'react';

import { RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

interface UseAutoSelectRecommendedParams {
  recommendedAssets: RecommendedAsset[];
  isLoading: boolean;
  templateId?: number;
  onAddAssets: (assets: RecommendedAsset[]) => void;
}

/**
 * Custom hook to auto-select recommended assets when they are first loaded
 */
const useAutoSelectRecommended = ({ recommendedAssets, isLoading, templateId, onAddAssets }: UseAutoSelectRecommendedParams): void => {
  useEffect(() => {
    if (recommendedAssets && Array.isArray(recommendedAssets) && recommendedAssets.length > 0 && !isLoading && templateId) {
      onAddAssets(recommendedAssets);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recommendedAssets, isLoading, templateId]);
};

export default useAutoSelectRecommended;
